export default __webpack_public_path__ + "82906ac2475f7359479fbe0cb47ffa64.png";